export default [
  'observeAuth',
]


// WEBPACK FOOTER //
// ./src/store/auth/types.js